import axios from "axios";
import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from "feather-icons-react";
import { toast } from "react-toastify";
class TerritoryForm extends Component{

    state = {
        id : null,
        name : "",
        error : "",
        territories : [],
        isModal : false,
        title : "",
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    async territories(){
        var request = await axios('territories');
        if(request.status === 200)
            this.setState({ territories : request.data  })
    }

    storeTerritory = () =>{
        var data = {
                name : this.state.name,
            }
        var request = this.state.id ? axios.put('territories/'+this.state.id, data) : axios.post('territories', data);
        request.then(async(response) =>{
            this.props.showModal(response.data.data);
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error) => {
            this.setState({ error : error.response?.data?.msg || "Une erreur est survenue." })
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }

    edit=()=>  {
        this.form()
        this.territories()
    }

    form=()=>{
        this.setState({
            id: this.props.formData ? this.props.formData.id : null,
            name: this.props.formData ? this.props.formData.name : "",
            error : "",
        })
    }

    render(){

        return(
            <div>
            <Modal
                show={this.props.isModal}
                onHide={this.props.showModal}
                size="lg"
                dialogClassName="student-form-dialog territory-form-dialog"
                contentClassName="student-form-modal student-form-modal--compact"
                onEntered={this.edit}
                backdrop={"static"}>
                <Modal.Header>
                    <div className="student-form__heading">
                        <span className="student-form__heading-icon">
                            <FeatherIcon icon="map-pin" size="20" />
                        </span>
                        <div>
                            <span className="student-form__eyebrow">Référentiel géographique</span>
                            <Modal.Title>{this.state.id ? "Modifier le region / territoire" : "Nouveau region / territoire"}</Modal.Title>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="student-form__body territory-form__body">
                    {this.state.error && (
                        <div className="student-form__alert" role="alert">
                            <FeatherIcon icon="alert-circle" size="17" />
                            <span>{this.state.error}</span>
                        </div>
                    )}

                    <div className="territory-form__grid">
                        <section className="territory-form__panel">
                            <div className="student-form__section-title">
                                <span><FeatherIcon icon="map" size="15" /></span>
                                <div>
                                    <strong>Region / Territoires enregistrés</strong>
                                    <small>Sélectionnez un region / territoire pour le modifier.</small>
                                </div>
                            </div>

                            <div className="territory-form__list">
                                {this.state.territories.length > 0 ? this.state.territories.map((territory) => (
                                    <button
                                        type="button"
                                        key={territory.id}
                                        className={`territory-form__item${this.state.id === territory.id ? " is-active" : ""}`}
                                        onClick={() => this.setState({ id : territory.id, name : territory.name, error : "" })}
                                    >
                                        <span><FeatherIcon icon="map-pin" size="15" /></span>
                                        <strong>{territory.name}</strong>
                                        <FeatherIcon icon="chevron-right" size="15" />
                                    </button>
                                )) : (
                                    <div className="territory-form__empty">
                                        <FeatherIcon icon="map" size="24" />
                                        <span>Aucun region / territoire enregistré</span>
                                    </div>
                                )}
                            </div>
                        </section>

                        <section className="territory-form__panel">
                            <div className="student-form__section-title">
                                <span><FeatherIcon icon="edit-3" size="15" /></span>
                                <div>
                                    <strong>Informations du region / territoire</strong>
                                    <small>Renseignez un libellé clair et unique.</small>
                                </div>
                            </div>

                            <div className="form-group has-icon-left territory-form__field">
                                <label htmlFor="territory-name">Nom du region / territoire</label>
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Ex. Region ou Territoire de ..."
                                        onChange={this.handleInput}
                                        name="name"
                                        value={this.state.name}
                                        id="territory-name"
                                        autoFocus
                                    />
                                    <div className="form-control-icon">
                                        <FeatherIcon icon="map-pin" />
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <span className="student-form__footer-note">
                        <FeatherIcon icon="info" size="14" />
                        Le region / territoire sera disponible dans les listes géographiques
                    </span>
                    <button type="button" onClick={this.props.showModal} className="btn btn-light student-form__button">
                        <FeatherIcon icon="x" size="16" /> Fermer
                    </button>
                    <button type="button" onClick={this.storeTerritory} className="btn btn-primary student-form__button">
                        <FeatherIcon icon="check" size="16" /> Sauvegarder
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
        )
    }
}
export default TerritoryForm;
